<template>
  <div class="chart-wrapper">
    <canvas :id="id"></canvas>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
import { randomId } from "../../helpers/general";

export default {
  name: "Chart",
  props: {
    type: {
      type: String,
      required: true,
      validator: function(value) {
        return (
          [
            "area",
            "bar",
            "bubble",
            "doughnut",
            "line",
            "pie",
            "polarArea",
            "radar",
            "scatter",
            "shadowLine"
          ].indexOf(value) !== -1
        );
      }
    },
    data: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      required: true
    },
    plugins: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      id: randomId()
    };
  },
  mounted() {
    const ctx = document.getElementById(this.id);
    new Chart(ctx, {
      type: this.type,
      data: this.data,
      options: this.options,
      plugins: this.plugins
    });
  }
};
</script>
